import { useState } from 'react';
import { LuInfo } from 'react-icons/lu';

import { Strategy, StrategyAllocation } from '@ndvr/portfolio-api';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { formatPercent } from 'utils';
import { StrategyDetailsDialog } from 'views/portfolio-engine/allocation-builder/strategies/StrategyDetailsDialog';

export type StrategyAllocationsProps = {
    strategyAllocations: StrategyAllocation[];
};

export const StrategyAllocations = ({ strategyAllocations }: StrategyAllocationsProps) => {
    const [selectedStrategy, setSelectedStrategy] = useState<Strategy>();
    const [isStrategyDetailsOpen, setIsStrategyDetailsOpen] = useState(false);

    const handleOpenStrategyDetails = (strategy: Strategy) => {
        setSelectedStrategy(strategy);
        setIsStrategyDetailsOpen(true);
    };

    const handleCloseStrategyDetails = () => {
        setSelectedStrategy(undefined);
        setIsStrategyDetailsOpen(false);
    };

    return (
        <>
            <div className="space-y-2 pt-3">
                <div className="flex items-center justify-between px-3">
                    <span className="text-sm font-medium text-gray-600">Strategy</span>
                    <span className="w-16 text-right text-sm font-medium text-gray-600">Target</span>
                </div>
                {[...strategyAllocations]
                    .sort((a, b) => Number(b.weight) - Number(a.weight))
                    .map((strategyAllocation) => (
                        <div
                            key={strategyAllocation.strategyGUID}
                            className="flex items-center justify-between rounded-md bg-gray-50 p-3"
                        >
                            <div className="flex items-center gap-3">
                                <span className="font-medium">{strategyAllocation.strategyName}</span>
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <div
                                            onClick={() => handleOpenStrategyDetails(strategyAllocation)}
                                            className="flex h-6 w-6 cursor-pointer items-center justify-center rounded-md hover:bg-gray-200"
                                        >
                                            <LuInfo className="h-4 w-4 text-gray-600" />
                                        </div>
                                    </TooltipTrigger>
                                    <TooltipContent>View Strategy Details</TooltipContent>
                                </Tooltip>
                            </div>
                            <span className="w-16 text-right font-semibold">
                                {formatPercent(parseFloat(strategyAllocation.weight) * 100)}
                            </span>
                        </div>
                    ))}
            </div>
            <StrategyDetailsDialog
                strategy={selectedStrategy}
                open={isStrategyDetailsOpen}
                onClose={handleCloseStrategyDetails}
            />
        </>
    );
};
